import { STATES } from '../../../../constants';

const PAGE_TITLE = 'Move Summary';

export default function Config($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.MOVES_SUMMARY, {
    url: '/:moveId/summary',
    views: {
      '@': {
        template: `<upd-moves-summary></upd-moves-summary>`,
      },
    },
    scrollTop: true,
    title: PAGE_TITLE,
    analytics: {
      page: PAGE_TITLE,
    },
  });
}
